<div class="startpage">
    <div class="container-column section" style="display: flex;">
        <div style="display: flex; flex-direction: column;">
            <div class="sectionstyle" style="white-space: nowrap;">
                <!--<section style="display: inline-block; vertical-align: middle;">Welcome to the iDocs
                    <sup style="font-size: x-small;">XD</sup> 
                    Portal for McDermott 
                </section>-->

                Welcome to the iDocs
                <sup style="font-size: x-small; vertical-align: super; line-height: 0;">XD</sup>
                Portal for McDermott
            </div>
            <div style="white-space: nowrap;">
                <span>Version: {{version}}</span>
            </div>
        </div>
        <a style="margin-left: 59%;"
            href="https://edms-plf.mcdermott.com/edms/redirect/getdocumentf?spec=0,2,277729733,-2,0,1326724346"
            target="_blank">
            <button style="color: #1825aa;height: 23px;margin-top: 18px;width: 50px;" type="button">Help</button></a>
    </div>
    <div id="center">
        <table class="center">
            <tr>
                <th class="s2c">Request Support</th>
            </tr>
            <tr>
                <td class="s2c"><a (click)="getUserDetails()" target="_blank"> <img
                            src="../../../assets/img/REQUEST_SUPPORT_ICON.png" alt="Request Support"
                            style="width: 100px; height: 78px; border: 0"></a></td>
            <tr>
        </table>
    </div>

    <div id="footer">
        <table class="footer">
            <col width=300pt>
            <col width=750pt>
            <tr>
                <th class="s2a" style="text-align: left; padding-left: 10pt;"><a href="https://www.McDermott.com"> <img
                            src="../../../assets/img/mcdermott_logo.png" alt="McDermott.com Webpage"
                            style="width: 260px; height: 40px; border: 0"></a></th>

                <th class="s2d" style="font-size: large;">
                    <button kendoButton class="allbuttons" (click)="openeWindow=true" style="border: #d7d6d6 1px solid"
                        [disabled]="false">
                        Terms & Conditions
                    </button>
                </th>
            </tr>
        </table>
    </div>
    <div>
        <kendo-window title="Terms & Conditions" *ngIf="openeWindow" (close)="closeAccessWindow()" [width]="650"
            [height]="550" [resizable]="false" style="top: 0; left: 5%">
            <div>
                <p style="margin-bottom: 10px;">By uploading documents to the iDocs<sup>XD</sup> Portal (McDermott FTP
                    site), you
                    acknowledge and agree to the
                    following terms:</p>

                <div style="margin: 0px 20px 10px 10px">
                    <b>1. Document Ownership:</b> Upon clicking "Submit" and uploading your documents, you transfer
                    ownership of
                    these documents to McDermott International Ltd. and its subsidiaries (McDermott). These documents
                    will be used for McDermott’s review and approval, and will be utilized in the delivery of the
                    products or services specified in the Order. Communications and information
                    transmitted by, accessed through, or stored in this system belong to McDermott. Users have no
                    expectation of privacy in relation to their use of and communications sent over McDermott's
                    Information Systems (including this system), and their use may be monitored as set out in
                    McDermott's Use of Company Communication Information Systems Policy IT-SEC-PL-00000.00 and
                    applicable local policies (subject always to applicable local laws including data privacy laws).

                </div>
                <div style="margin: 0px 20px 10px 10px">
                    <b>2. Security Compliance:</b> All uploaded documents must comply with McDermott's security
                    policies. We
                    will
                    conduct a security scan on all documents uploaded to ensure they meet our standards. Further,
                    McDermott may monitor the use of its systems, including reviewing login records, records of usage,
                    and communications sent over its systems.

                </div>
                <div style="margin: 0px 20px 10px 10px">
                    <b>3. Document Modifications:</b> If any changes are required to the uploaded documents, you must
                    re-upload
                    the revised documents through the iDocs<sup>XD</sup> Portal. Each new upload will be subject to the
                    same
                    ownership transfer and security compliance terms.
                </div>
                By proceeding with the upload, you confirm that you understand and accept these terms.
            </div>
            <div>
                <button class="k-dialog-content" (click)="closeAccessWindow()" type="button">Close</button>
                <ng-container kendoDialogContainer></ng-container>
            </div>
        </kendo-window>
    </div>
</div>